module.exports = __webpack_public_path__ + "static/img/deal_15.4cf202f1.png";